/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Box, styled } from '@mui/material';

export const MarginStyledBox = styled(Box)({
  display: 'block',
  margin: '12px',
});

export const FullScreenStyledBox = styled(Box)((props: { mobileNavbarAllowance?: boolean }) => ({
  overflow: 'auto',
  display: 'block',
  position: 'absolute',
  top: '0',
  bottom: props.mobileNavbarAllowance ? '80px' : '0',
  left: '0',
  right: '0',
}));
